<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isLoading"></loader>
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <v-toolbar-title>
                <h3 style="overflow-wrap: normal">Lista de potenciales</h3>
            </v-toolbar-title>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-peticion` }"
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo potencial</span>
        </v-tooltip>

        <!--Filtros-->
        <v-row>
            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>

            <v-col cols="12" md="4">
                <v-btn
                    color="primary"
                    class="white--text mr-2"
                    @click="getPeticiones()"
                >
                    Filtrar
                </v-btn>
                <v-btn
                    color="red"
                    class="white--text mr-2"
                    @click="
                        filtros = {};
                        filtros_prueba = {};
                        getPeticiones();
                    "
                >
                    Limpiar filtros
                </v-btn>
                <v-btn color="success" @click="ExportExcel">
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
            @click:row="
                (item) => $router.push(`/guardar-peticion?id=${item.id}`)
            "
            dense
            :loading="isLoading"
            :headers="headers"
            :items="peticiones"
            :item-class="getRowClass"
            item-key="id"
            class="elevation-1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :footer-props="{
                'items-per-page-options': [100, 500],
            }"
            :server-items-length="total"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.fecha_alta="{ item }">
                <span>{{
                    (item.fecha_alta + "T" + item.created_at.split("T")[1])
                        | format_date_time_madrid
                }}</span>
            </template>
            <template v-slot:item.tipo="{ item }">
                <span v-if="item.incidencia">Incidencia</span>
                <span v-else>Presupuesto</span>
            </template>

            <template v-slot:item.action="{ item }">
                <a
                    target="__blank"
                    :href="`tel:${item.telefono}`"
                    @click.stop="() => {}"
                    ><v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="blue"
                        title="Llamar"
                        >mdi-phone</v-icon
                    ></a
                >
                <a
                    target="__blank"
                    :href="`https://wa.me/${item.telefono}`"
                    @click.stop="() => {}"
                    ><v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="green"
                        title="Whatsapp"
                        >mdi-whatsapp</v-icon
                    ></a
                >

                <a
                    @click.stop="
                        selectedItem = item;
                        dialog = true;
                    "
                >
                    <v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="red"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deletePeticion()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <DialogMail
            v-model="dialog_mail"
            :id_cliente="peticion.cliente.id"
            :id_producto="peticion.interes"
        >
        </DialogMail>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
import DialogMail from "../../clientes/componentes/DialogMail.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";

export default {
    components: {
        FilterComponentVue,
        DialogMail,
    },
    data() {
        return {
            peticiones: [],
            total: 0,
            page: 1,
            cantidad: 100,
            sortBy: [],
            sortDesc: [],
            headers: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    // value: "cliente.nombre_comercial",
                    value: "nombre",
                    sortable: true,
                },
                {
                    text: "Teléfono",
                    // value: "cliente.telefono",
                    value: "telefono",
                    sortable: true,
                },
                {
                    text: "Población",
                    // value: "cliente.dir.ciudad",
                    value: "ciudad",
                    sortable: true,
                },
                {
                    text: "Dirección",
                    // value: "cliente.dir.direccion",
                    value: "direccion",
                    sortable: true,
                },
                {
                    text: "Provincia",
                    // value: "cliente.dir.provincia_rel.nombre",
                    value: "provincia",
                    sortable: true,
                },
                {
                    text: "Email",
                    // value: "cliente.email",
                    value: "email",
                    sortable: true,
                },
                {
                    text: "Comercial",
                    // value: "agente.nombre",
                    value: "comercial",
                    sortable: true,
                },
                {
                    text: "Creado por",
                    // value: "user.name",
                    value: "creado_por",
                    sortable: true,
                },
                {
                    text: "Estado",
                    // value: "estado.nombre",
                    value: "estado",
                    sortable: true,
                },
                {
                    text: "Interesado",
                    // value: "interesado.nombre",
                    value: "interesado",
                    sortable: true,
                },
                {
                    text: "¿Cómo nos conocieron?",
                    // value: "cliente_conocidos.name",
                    value: "conocido",
                    sortable: true,
                },
                {
                    text: "Tipo",
                    value: "tipo",
                    sortable: true,
                },
                {
                    text: "Fecha de alta",
                    value: "fecha_alta",
                    sortable: true,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            dialog: false,
            selectedItem: null,
            filtros_prueba: {
                search: "",
            },
            filter_headers: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Agente",
                    type: "select",
                    active: false,
                    model: "id_agente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "id_estado_potencial",
                    item_text: "nombre",
                    item_value: "id",
                },
            ],
            dialog_mail: false,
            peticion: {
                cliente: {},
            },
        };
    },
    created() {
        if (this.$store.getters.getfiltros["peticiones"] != null) {
            this.filtros_prueba = this.$store.getters.getfiltros["peticiones"];
        }
        // this.getPeticiones();

        this.getEstadosPotencial();
        this.getAgentes();
    },
    methods: {
        ExportExcel() {
            let filtros = this.filterString;
            axios
                .get(`/api/peticiones/excel?filtro=null${filtros}`, {
                    responseType: "blob",
                })
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "potenciales.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exportando peticiones:", error);
                });
        },
        getRowClass(item) {
            if (item.agente != null)
                if (item.agente.estadistica == 0) {
                    return "yellow";
                }

            return "pointer";
        },
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.filter_headers[2].items = res.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[1].items = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                    this.agentes = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        openMailModal(item) {
            this.dialog_mail = true;
            console.log(item);
            this.peticion = item;
        },
        deletePeticion() {
            axios.delete(`api/peticiones/${this.selectedItem.id}`).then(
                (res) => {
                    this.$toast.sucs("Petición eliminada con éxito");
                    this.dialog = false;
                    this.getPeticiones();
                },
                (err) => {
                    this.$custom_error("Error eliminando la petición");
                }
            );
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getPeticiones();
            //console.log(`evento: ${event}`);
        },
        ChangePage(event) {
            this.page = event.page;
            this.getPeticiones();
            //console.log(event);
        },
        getPeticiones() {
            /*let filtros = this.filterString;
            let sortParams = "";

            if (this.sortBy && this.sortBy.length > 0) {
                sortParams = `&sort_by=${this.sortBy.join(
                    ","
                )}&sort_desc=${this.sortDesc.join(",")}`;
            }
            const res = await axios.get(
                `api/peticiones?page=${this.page}&amount=${this.cantidad}${filtros}${sortParams}`
            );*/

            let params = {
                page: this.page,
                amount: this.cantidad,
                sort_by: this.sortBy.join(","),
                sort_desc: this.sortDesc.join(","),
            };
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                params.busqueda = this.filtros_prueba.search;
            }
            if (
                this.filtros_prueba.fecha?.start != null &&
                this.filtros_prueba.fecha?.start != ""
            ) {
                params.fecha_desde = this.filtros_prueba.fecha?.start;
            }
            if (
                this.filtros_prueba.fecha?.end != null &&
                this.filtros_prueba.fecha?.end != ""
            ) {
                params.fecha_hasta = this.filtros_prueba.fecha?.end;
            }
            if (
                this.filtros_prueba.id_agente &&
                (this.filtros_prueba.id_agente.value === 0 ||
                    (this.filtros_prueba.id_agente.value !== "" &&
                        this.filtros_prueba.id_agente.value !== null &&
                        this.filtros_prueba.id_agente.value !== undefined))
            ) {
                params.id_agente = this.filtros_prueba.id_agente.value;
            }
            if (
                this.filtros_prueba.id_estado_potencial?.value != null &&
                this.filtros_prueba.id_estado_potencial?.value != ""
            ) {
                params.id_estado_potencial =
                    this.filtros_prueba.id_estado_potencial?.value;
            }

            axios
                .get(`api/peticiones`, {
                    params: params,
                })
                .then((res) => {
                    console.log("res", res);
                    this.peticiones = res.data.data;
                    this.total = res.data.total;
                });
        },
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                this.$store.dispatch("saveFiltrosPeticiones", val);
            },
        },
        sortBy: {
            handler: debounce(function (newVal, oldVal) {
                this.getPeticiones();
            }, 100),
            deep: true,
        },
        sortDesc: {
            handler: debounce(function (newVal, oldVal) {
                this.getPeticiones();
            }, 100),
            deep: true,
        },
    },
    computed: {
        isLoading: function () {
            return this.$store.getters.getloading;
        },
        filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else {
                        if (
                            (this.filtros_prueba[head.model].value != "" &&
                                this.filtros_prueba[head.model].value !=
                                    null) ||
                            (this.filtros_prueba[head.model].nombre != "" &&
                                this.filtros_prueba[head.model].nombre != null)
                        ) {
                            filtros += `&${head.model}=${
                                this.filtros_prueba[head.model].value
                            }`;
                        }
                    }
                }
            });
            return filtros;
        },
    },
};
</script>
